import { addDays, makeIsoDate, weekdayOf } from './date';
import { movableFeast } from './easter';
export const BUNDESLAENDER = [
    'BW', 'BY', 'BE', 'BB', 'HB', 'HH', 'HE', 'MV',
    'NI', 'NW', 'RP', 'SL', 'SN', 'ST', 'SH', 'TH',
];
/** German names, for the user interface. */
export const BUNDESLAND_NAMES = {
    BW: 'Baden-Württemberg',
    BY: 'Bayern',
    BE: 'Berlin',
    BB: 'Brandenburg',
    HB: 'Bremen',
    HH: 'Hamburg',
    HE: 'Hessen',
    MV: 'Mecklenburg-Vorpommern',
    NI: 'Niedersachsen',
    NW: 'Nordrhein-Westfalen',
    RP: 'Rheinland-Pfalz',
    SL: 'Saarland',
    SN: 'Sachsen',
    ST: 'Sachsen-Anhalt',
    SH: 'Schleswig-Holstein',
    TH: 'Thüringen',
};
/** Default for new projects, per decision A-11. */
export const DEFAULT_BUNDESLAND = 'BE';
const FRONLEICHNAM_STATEWIDE = ['BW', 'BY', 'HE', 'NW', 'RP', 'SL'];
const FRONLEICHNAM_PARTIAL = ['SN', 'TH'];
const HEILIGE_DREI_KOENIGE = ['BW', 'BY', 'ST'];
const FRAUENTAG = ['BE', 'MV'];
const REFORMATIONSTAG = ['BB', 'HB', 'HH', 'MV', 'NI', 'SN', 'ST', 'SH', 'TH'];
const ALLERHEILIGEN = ['BW', 'BY', 'NW', 'RP', 'SL'];
/**
 * Buss- und Bettag: the Wednesday before 23 November, so always between the
 * 16th and the 22nd. A public holiday only in Saxony.
 */
export function bussUndBettag(year) {
    let date = makeIsoDate(year, 11, 22);
    while (weekdayOf(date) !== 3) {
        date = addDays(date, -1);
    }
    return date;
}
/**
 * All public holidays of one state in one year, sorted by date.
 *
 * Sundays are included where they are legally holidays (Ostersonntag and
 * Pfingstsonntag in Brandenburg). That makes no practical difference, since a
 * Sunday is a non-working day anyway, but it keeps the list truthful.
 */
export function holidaysFor(bundesland, year, options = {}) {
    const holidays = [
        { date: makeIsoDate(year, 1, 1), name: 'Neujahr', nationwide: true },
        { date: movableFeast('karfreitag', year), name: 'Karfreitag', nationwide: true },
        { date: movableFeast('ostermontag', year), name: 'Ostermontag', nationwide: true },
        { date: makeIsoDate(year, 5, 1), name: 'Tag der Arbeit', nationwide: true },
        { date: movableFeast('christiHimmelfahrt', year), name: 'Christi Himmelfahrt', nationwide: true },
        { date: movableFeast('pfingstmontag', year), name: 'Pfingstmontag', nationwide: true },
        { date: makeIsoDate(year, 10, 3), name: 'Tag der Deutschen Einheit', nationwide: true },
        { date: makeIsoDate(year, 12, 25), name: '1. Weihnachtstag', nationwide: true },
        { date: makeIsoDate(year, 12, 26), name: '2. Weihnachtstag', nationwide: true },
    ];
    const add = (date, name) => {
        holidays.push({ date, name, nationwide: false });
    };
    if (HEILIGE_DREI_KOENIGE.includes(bundesland)) {
        add(makeIsoDate(year, 1, 6), 'Heilige Drei Könige');
    }
    if (FRAUENTAG.includes(bundesland)) {
        add(makeIsoDate(year, 3, 8), 'Internationaler Frauentag');
    }
    if (bundesland === 'BB') {
        add(movableFeast('ostersonntag', year), 'Ostersonntag');
        add(movableFeast('pfingstsonntag', year), 'Pfingstsonntag');
    }
    if (FRONLEICHNAM_STATEWIDE.includes(bundesland) ||
        (FRONLEICHNAM_PARTIAL.includes(bundesland) && options.fronleichnam === true)) {
        add(movableFeast('fronleichnam', year), 'Fronleichnam');
    }
    if (bundesland === 'SL' ||
        (bundesland === 'BY' && options.mariaeHimmelfahrt === true)) {
        add(makeIsoDate(year, 8, 15), 'Mariä Himmelfahrt');
    }
    if (bundesland === 'TH') {
        add(makeIsoDate(year, 9, 20), 'Weltkindertag');
    }
    if (REFORMATIONSTAG.includes(bundesland)) {
        add(makeIsoDate(year, 10, 31), 'Reformationstag');
    }
    if (ALLERHEILIGEN.includes(bundesland)) {
        add(makeIsoDate(year, 11, 1), 'Allerheiligen');
    }
    if (bundesland === 'SN') {
        add(bussUndBettag(year), 'Buß- und Bettag');
    }
    return holidays.sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
}
/** Holidays across a span of years, for building a calendar. */
export function holidaysForYears(bundesland, fromYear, toYear, options = {}) {
    const all = [];
    for (let year = fromYear; year <= toYear; year++) {
        all.push(...holidaysFor(bundesland, year, options));
    }
    return all;
}
//# sourceMappingURL=holidays.js.map